// extracted by css-extract-rspack-plugin
export default {"ColumnSeries":"ColumnSeries--lwR1e"};